<app-base-modal [isOpen]="isOpen" (close)="onClose()">
  <h1 header>Edit cover page</h1>

  <app-cover-page-form
    [isSaving]="isSaving"
    [coverPage]="coverPage"
    [clientNumbers]="clientNumbers"
    (save)="onSubmit($event)"
  ></app-cover-page-form>
</app-base-modal>
